import { ToneCardCSSStyleImpl } from '../../home/featuredcategory/viewmodel/tonecard/tonecardcssstyle';

export class NameTuneCardCSSStyleImpl extends ToneCardCSSStyleImpl
{
    // getToneWrapperCSSStyle(marginTop: string): object
    // {
    //     return {
    //         height: '280px', 
    //         width: '262px', 
    //         marginRight: "40px",
    //         marginTop: marginTop,
    //         objectFit: 'cover', 
    //         position: 'relative',
    //         cursor: "pointer",
    //         borderRadius:'50px 0px 50px 0px'
    //     };
    // }
    // getOnHoverCSSStyle(): object 
    // {
    //     return {
    //         objectFit: 'cover', 
    //         position: 'absolute',
    //         height: '280px', 
    //         width: '262px', 
    //         borderRadius:'50px 0px 50px 0px',
    //         display: "flex",
    //         paddingLeft: "20px",
    //         paddingRight: "20px",
    //         paddingTop: "20px",
    //         opacity:'0.75',
    //         backgroundColor:"#003187"
    //         // background: "linear-gradient(0deg, #000000 0%, rgba(0,0,0,0.73) 100%)"
    //     };
    // }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/nametunes/nametunecard/nametunecardcss.tsx